module.exports = __webpack_public_path__ + "static/media/ezgif.com-optimize (2).c1ce83be.gif";